import React from 'react';

import {BUTTON_DIMENSIONS} from '../constants';
import type {BoneButtonProps} from '../types';

import {Bone} from './Bone';

export const BoneButton: React.FC<BoneButtonProps> = React.memo(
  ({variant = 'primary', width = '100%', ...rest}) => {
    const dims = BUTTON_DIMENSIONS[variant];
    return <Bone width={width} height={dims.height} borderRadius={dims.borderRadius} {...rest} />;
  },
);
BoneButton.displayName = 'BoneButton';
